<template>
  <div class="set-title">
    <el-dialog
      title="条约查看记录"
      :visible="true"
      @close="handleClose"
      width="860px"
    >

      <div>
        <el-row class="search-row">
          <el-col :span="8" class="display-row">
            <div class="query-title">客户名称:</div>
            <div class="flex1">
              <el-input placeholder="请输入" clearable v-model="queryInfo.userId" size="small"></el-input>
            </div>
          </el-col>
          <el-col :span="8" class="display-row">
            <div class="query-title">开始时间:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.startTime" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                              placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="8" class="display-row">
            <div class="query-title">结束时间:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.endTime" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                              placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="8" class="display-row">
            <div class="query-title">文档名称:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.type" placeholder="请选择" size="small" clearable>
                <el-option key="1" value="1" label="アリパートナーズ株式会社サービス利用規約(1.3)"></el-option>
                <el-option key="2" value="2" label="プライバシーポリシー"></el-option>
              </el-select>
            </div>
          </el-col>

          <el-col :span="16" class="display-row">
            <div style="text-align: right; width: 100%;">
              <el-button class="search-btn btn-gray" @click="clearConditions">重置</el-button>
              <el-button style="margin-right: 0!important;" class="search-btn btn-blue" @click="searchCustomer">搜索</el-button>
            </div>
          </el-col>
        </el-row>

      </div>

      <hx-table
        :tableColumn="tableColumn"
        :tableData="tableData"
        :height="360"
      >
      </hx-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
                     :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
                     :total="total"></el-pagination>
      <div class="dialog-footer">
        <el-button class="search-btn btn-blue" @click="handleClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "stock-order",
    props: {
      row: {
        type: Object,
        default: ()=>({})
      }
    },
    data(){
      return{
        tableData: [],
        tableColumn: [
          {
            label: '序号',
            width: 50,
            type: 'index'
          },
          {
            prop: 'userId',
            label: '客户名称'
          },
          {
            prop: 'readTime',
            width: 180,
            label: '访问时间'
          },
          {
            prop: 'typeStr',
            label: '查看文档名称'
          }
        ],
        queryInfo: {
          userId: "",
          type: "",
          startTime: "",
          endTime: "",
          pageSize: 10,
          pageNum: 1,
        },
        total: 0
      }
    },
    created() {
      this.getList()
    },
    methods: {
      async getList(){

        const res = await this.$http.get('customer/userReadListPage', {
          params: this.queryInfo,
        });
        if (res.data.code == 200){
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        }
      },
      handleClose () {
        this.$options.cancel('cancel')
      },
      handleSizeChange (pageSize) {
        this.queryInfo.pageSize = pageSize;
        this.getList();
      },
      handleCurrentChange (pageNumber) {
        this.queryInfo.pageNum = pageNumber;
        this.getList();
      },
      searchCustomer () {
        this.queryInfo.pageNum = 1;
        this.queryInfo.pageSize = 10;
        this.getList();
      },
      clearConditions () {
        this.queryInfo.startTime = '';
        this.queryInfo.endTime = '';
        this.queryInfo.userId = '';
        this.queryInfo.type = '';
      },
    }
  }
</script>

<style scoped lang="less">
  .set-title {
    .query-title{
      width: 85px;
    }
    ::v-deep .el-dialog__header {
      text-align: center;
    }
    ::v-deep .el-dialog__body{
      padding-top: 10px;
    }
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
    }
    ::v-deep .el-input-number--medium {
      width: 100%;
    }
    ::v-deep .el-input-number.is-without-controls .el-input__inner {
      text-align: left;
    }
    .w100{
      width: 100%;
      position: relative;
      span{
        position: absolute;
        top: 0;
        right: 10px;
      }
    }
    .w50{
      display: flex;
      width: 49%;
      position: relative;
      span{
        position: absolute;
        top: 0;
        right: 10px;
      }
    }
  }
</style>
